import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OneDriveService } from 'src/app/services/core/onedrive.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
  constructor(
    private oneDriveService: OneDriveService,
    private router: Router
  ) {}

  ngOnInit() {
    this.oneDriveService.handleRedirect();
  }
}
